"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_use_1 = require("react-use");
var styles_1 = require("./styles");
function Dropdown(_a) {
    var anchor = _a.anchor, _b = _a.from, from = _b === void 0 ? 'left' : _b, children = _a.children, closeOn = _a.closeOn, commonProps = __rest(_a, ["anchor", "from", "children", "closeOn"]);
    var _c = __read(react_1.default.useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var toggleIsOpen = react_1.default.useCallback(function () { return setIsOpen(!isOpen); }, [isOpen]);
    var wrapperRef = react_1.default.useRef(null);
    var anchorRef = react_1.default.useRef(null);
    (0, react_use_1.useClickAway)(wrapperRef, function () {
        setIsOpen(false);
    });
    (0, react_use_1.useKey)('Escape', function () {
        var _a, _b;
        if (!isOpen)
            return;
        if ((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) {
            (_b = anchorRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        setIsOpen(false);
    }, {
        event: 'keyup',
    }, [isOpen]);
    (0, react_use_1.useKey)(function (e) { return e.key === 'ArrowDown' && document.activeElement === anchorRef.current; }, function (e) {
        e.preventDefault();
        setIsOpen(true);
    }, {
        event: 'keyup',
    });
    (0, react_use_1.useKey)('Tab', function () {
        var _a;
        if (!isOpen)
            return;
        if (!((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement))) {
            setIsOpen(false);
        }
    }, { event: 'keyup' }, [isOpen, wrapperRef.current]);
    (0, react_use_1.useKey)(function (e) { return e.key === 'Enter' && document.activeElement === anchorRef.current; }, function () {
        toggleIsOpen();
    }, { event: 'keyup' });
    react_1.default.useEffect(function () {
        if (closeOn) {
            setIsOpen(false);
        }
    }, [closeOn]);
    var anchorProps = react_1.default.useMemo(function () { return ({
        isOpen: isOpen,
        tabIndex: 0,
        ref: anchorRef,
        onClick: function (e) {
            if (e.detail === 0)
                return;
            toggleIsOpen();
        },
    }); }, [isOpen, toggleIsOpen]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "Dropdown" }, commonProps, { ref: wrapperRef }),
        anchor(anchorProps),
        isOpen && children({ from: from })));
}
exports.default = Dropdown;
